module.exports = __webpack_public_path__ + "static/media/men-suites-pants-dress-shoes-street-sidewalk-min.3d9fd82c.jpg";